import { ReactNode } from 'react'
import { useNavigate } from 'react-router-dom'
import { regular } from '@fortawesome/fontawesome-svg-core/import.macro'

import { Icon, Text, Button, Separator } from '@/ui'
import { TypographyStyles } from '@/styles'
import { useIsDeviceWidth, DeviceWidth } from '@/utils/deviceWidthHelpers'

export const PageHeader = ({
  header,
  isMultiStep,
  extraContent,
  backControl,
  divider = true,
  className,
}: {
  header: string
  isMultiStep?: boolean
  extraContent?: ReactNode
  backControl?: {
    link: string | -1
    text: string
  }
  divider?: boolean
  className?: string
}) => {
  const navigate = useNavigate()
  const isMobile = useIsDeviceWidth(DeviceWidth.mobile)
  let size: keyof typeof TypographyStyles = 'H1'

  if (isMultiStep) {
    size = 'H3'
  } else if (isMobile) {
    size = 'H2'
  }

  const leftMarginStyle = isMobile ? 'ml-4' : ''
  return (
    <div
      className={`flex flex-col gap-2 ${className} w-full mb-2 ${isMobile ? 'pl-4' : ''}`}
    >
      {backControl && (
        <div className="flex flex-col">
          <div className="short" />
          <div className={`flex ${leftMarginStyle}`}>
            {/* @ts-expect-error -- -1 is a valid parameter that navigates to the last page on the stack */}
            <Button onClick={() => navigate(backControl.link)} variant="link">
              <Icon icon={regular('arrow-left')} className="mr-4" />
              {backControl.text}
            </Button>
          </div>
          {divider && <Separator />}
        </div>
      )}
      <div
        className={`flex ${isMobile ? 'flex-col' : 'flex-row'} justify-between`}
      >
        <Text variant={TypographyStyles[size]} className={leftMarginStyle}>
          {header}
        </Text>
        <div
          className={`flex items-end max-w-[250px] ${isMobile ? 'pr-5 mt-2' : ''}`}
        >
          {extraContent}
        </div>
      </div>
    </div>
  )
}
